import { Chip } from '@bp/ui-components';

/**
 * Marker for OmniAdmin-only solver surfaces (currently the Timefold score analysis / score-debug).
 * Signals that the surface is restricted to internal omni administrators, not regular users —
 * deliberately a neutral grey, distinct from the public-facing {@link BetaChip}.
 */
export const OmniChip = () => (
  <Chip value='Omni' bgColor='var(--color-grey-lighter)' color='var(--color-grey-darkest)' />
);
